Splide.defaults = {
  type   : 'loop',
}

// 無限スライダー
const loop_slider = document.getElementsByClassName('js-slider_loop');
for (var i = 0; i < loop_slider.length; i++) {
  const loop_slider_img = new Splide(loop_slider[i], {
    arrows: false,
    pagination: false,
    drag: false,
    fixedWidth: '23.44%',
    breakpoints: {
      841: {
        fixedWidth: '44.1vw',
      },
    },
    autoScroll: {
      speed: 0.6,
      pauseOnHover: false,
    },
  });
  loop_slider_img.mount(window.splide.Extensions);
}


// 新車カード無限スライダー
const car_cards = document.getElementsByClassName('js-slider_car-cards');
for (var i = 0; i < car_cards.length; i++) {
  const car_card = new Splide(car_cards[i], {
    arrows: false,
    pagination: false,
    drag: false,
    fixedWidth: '240px',
    gap: '16px',
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
    },
  });
  car_card.mount(window.splide.Extensions);
}

// トップページ KVスライダー
const top_kvs = document.getElementsByClassName('js-slider_top_kvs');
for (var i = 0; i < top_kvs.length; i++) {
  const top_kv = new Splide(top_kvs[i], {
    arrows: false,
    pagination: false,
    speed: 1000,
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    breakpoints: {
      841: {
        speed: 800
      },
    },
  });
  top_kv.mount();
}